import { type Resolver, teamCategory } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

type Arguments = {
    leadUserIds?: string[];
};

export const schemaUserResolver_GetAdvisersByRole = z.array(
    UsersTableDefinitionZod.pick({
        assignable: true,
        buckets: true,
        firstName: true,
        id: true,
        lastName: true,
        role: true,
        state: true,
    }).extend({
        // Derived from the absence entries so the reason and delegate of a colleague's absence stay private.
        absent: z.boolean(),
        // lead user outside the caller's scope: only for resolving the name, never an assignment target
        nameOnly: z.boolean(),
        teamCategory,
    }),
);

export type SchemaUserResolver_GetAdvisersByRole = z.infer<typeof schemaUserResolver_GetAdvisersByRole>;

export type UserResolver_GetAdvisersByRole = Resolver<Arguments, SchemaUserResolver_GetAdvisersByRole>;
